import {
    RiArticleLine,
    RiInfoCardLine,
} from "@remixicon/react";
import React from "react";
import {
    Article,
    ArticleType,
    GetArticleDocument,
    ListArticleVersionsDocument,
    useUpdateArticleTypeMutation,
} from "../../../__generated__/api";
import { useConfirm } from "../../../components/confirm/Confirm";
import Dropdown from "../../../components/theme/dropdown/Dropdown";
import Icon from "../../../components/theme/icon/Icon";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";

export default function ChangeTypeButton({
    article,
    onClick,
}: {
    article: Article | undefined | null,
    onClick?: () => void
}) {
    const [changeType] = useUpdateArticleTypeMutation();

    const { element: publishElement, setShouldShow: setShowPublish } = useConfirm({
        title: `Convert to ${article?.type === ArticleType.Knowledge ? "Article" : "Knowledge"}`,
        confirmText: "Convert",
        closeText: "Cancel",
        confirmMetricPath: [LoggingHandler.Metrics.ARTICLES, "convert", article?.type?.toLowerCase() as string],
        onConfirm: async () => {
            await changeType({
                refetchQueries: [
                    { query: GetArticleDocument, variables: { id: article?.id } },
                    { query: ListArticleVersionsDocument, variables: { id: article?.id } },
                ],
                variables: {
                    id: article?.id,
                    change: {
                        type: article?.type === ArticleType.Knowledge ? ArticleType.Article : ArticleType.Knowledge,
                    },
                },
            });

            onClick?.();
        },
        body: article?.type === ArticleType.Knowledge
            ? `Converting to an article will make it available to all users in the system.`
            : `Converting to knowledge will make the content of the article available to AI
            but not visible to users. Even when published.`,
    });

    return (
        <>
            {publishElement}
            <Dropdown.Item
                onClick={() => {
                    setShowPublish(true);
                    onClick?.();
                }}
                prefixIcon={(
                    <Icon icon={article?.type === ArticleType.Knowledge
                        ? <RiArticleLine />
                        : <RiInfoCardLine />}
                    />
                )}
            >
                {article?.type === ArticleType.Knowledge ? "Convert to Article" : "Convert to Knowledge"}
            </Dropdown.Item>
        </>
    );
}

ChangeTypeButton.defaultProps = {
    onClick: undefined,
};
